"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cityIn = cityIn;
exports.cityFrom = cityFrom;
exports.cityTo = cityTo;

var _utils = require("./utils");

var _gender = require("./gender");

var _inclineRules = require("./inclineRules");

var _incline = require("./incline");

var _cityRules = require("./rules/cityRules");

/* eslint-disable no-use-before-define, no-continue, arrow-parens */
(0, _inclineRules.constantizeGenderInRules)(_cityRules.cityRules);

function declineTo(name, wordCase, gender) {
  if (isFrozen(name, _cityRules.frozenWords)) return name;
  return name.split(/(\s|-)/g).map(function (part, i, parts) {
    if (isFrozenPart(part, i, parts)) return part;
    var rule = (0, _inclineRules.findRule)(part, _gender.ANDROGYNOUS, _cityRules.cityRules);

    if (rule) {
      return (0, _inclineRules.applyRule)(rule, part, wordCase);
    }

    return (0, _incline.inclineFirstname)(part, wordCase, gender) || part;
  }).join('');
} // предложный, в каком городе живете/находитесь?


function cityIn(name, gender) {
  return declineTo(name, _inclineRules.PREPOSITIONAL, gender);
} // родительный, из какого города приехали?


function cityFrom(name, gender) {
  return declineTo(name, _inclineRules.GENITIVE, gender);
} // винительный, в какой город направляетесь?


function cityTo(name) {
  if (!name) return name;
  return name.split(/(\s|-)/g).map(function (part, i, parts) {
    if (isFrozenPart(part, i, parts)) return part;
    var partLower = part.toLowerCase();

    if ((0, _utils.endsWith)(partLower, 'а')) {
      return (0, _inclineRules.applyMod)(part, '-у');
    } else if ((0, _utils.endsWith)(partLower, 'ая')) {
      return (0, _inclineRules.applyMod)(part, '--ую');
    } else if ((0, _utils.endsWith)(partLower, 'ия')) {
      return (0, _inclineRules.applyMod)(part, '--ию');
    } else if ((0, _utils.endsWith)(partLower, 'я')) {
      return (0, _inclineRules.applyMod)(part, '-ю');
    }

    return part;
  }).join('');
}

function isFrozen(str, words) {
  var strLower = str.toLowerCase();

  for (var k = 0; k < words.length; k++) {
    if (words[k] === strLower) {
      return true;
    }
  }

  return false;
}

function isFrozenPart(part, i, parts) {
  if (parts.length > 1) {
    if (isFrozen(part, _cityRules.frozenParts)) return true;

    for (var k = 0; k < i; k++) {
      if (isFrozen(parts[k], _cityRules.frozenPartsAfter)) return true;
    }
  }

  return false;
}